<template>
  <base-floating-card @close="close">
    <div id="add-note-wrapper">
      <TextArea
        class="scs-input"
        heading="Note"
        @scs-input="bodyInput"
        placeholder="Note Body Here"
      />
      <p class="note-date">~ {{ formatDate(note.date) }}</p>
      <div id="add-note-button-wrapper">
        <Button
          class="scs-button"
          text="Close"
          :processing="processing"
          @click="close"
        /><Button
          class="scs-button"
          text="Save"
          :processing="processing"
          @click="save"
        />
      </div>
    </div>
  </base-floating-card>
</template>
<script>
import BaseFloatingCard from "../BaseFloatingCard.vue";

import TextArea from "../../../Elements/TextArea.vue";
import Button from "../../../UI/Button.vue";
import { formatDate } from "../../../../Helpers/invoice";
export default {
  data() {
    return {
      note: {
        tenant: this.$store.getters.user.tenantId,
        date: new Date(),
        body: undefined,
      },
      processing: false,
    };
  },
  methods: {
    formatDate,
    bodyInput(value) {
      this.note.body = value;
    },
    close() {
      this.$emit("close");
    },
    async save() {
      if (this.note.body) {
        this.processing = true;
        let parameters = {
          subject: this.contact,
          api_version: this.contact.api_version,
          variable: "notes",
          value: this.note,
          key: {
            userId: this.contact.userId,
            tenantId: this.contact.tenantId,
          },
          operation: "add",
        };
        await this.$store.dispatch("editContact", parameters);
        this.close();
      }
    },
    isPublic(option) {
      if (option === true) {
        return "Public";
      } else {
        return "Private";
      }
    },
  },
  created() {},
  components: {
    BaseFloatingCard,
    Button,
    TextArea,
  },
  emits: ["close"],
  props: ["contact"],
};
</script>
<style scoped>
@media screen {
  #add-note-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .note-date {
    font-size: 0.7rem;
    margin: 5px;
    width: 100%;
    text-align: right;
  }
  .scs-input {
    width: 100%;
    height: 300px;
  }

  #add-note-button-wrapper {
    width: 100%;
    display: flex;
  }

  .scs-button {
    margin: 10px 10px 0 10px;
  }
  @media (min-width: 800px) {
    #add-note-wrapper {
      width: 375px;
      height: 375px;
    }
  }
}
</style>
